import { render, staticRenderFns } from "./remove-products.vue?vue&type=template&id=c18f0b62&scoped=true&"
import script from "./remove-products.vue?vue&type=script&lang=js&"
export * from "./remove-products.vue?vue&type=script&lang=js&"
import style0 from "./remove-products.vue?vue&type=style&index=0&id=c18f0b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18f0b62",
  null
  
)

export default component.exports